module.exports = __webpack_public_path__ + "img/card-eligiblestudentsbyentity.e7e941ce.svg";